import { createSvgIcon } from '@mui/material/utils';

export const LinkAlt = createSvgIcon(
  <svg viewBox="0 0 18 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.25001 5.00004C2.25001 3.57504 3.40834 2.41671 4.83334 2.41671H8.16667V0.833374H4.83334C2.53334 0.833374 0.666672 2.70004 0.666672 5.00004C0.666672 7.30004 2.53334 9.16671 4.83334 9.16671H8.16667V7.58337H4.83334C3.40834 7.58337 2.25001 6.42504 2.25001 5.00004ZM5.66667 5.83337H12.3333V4.16671H5.66667V5.83337ZM13.1667 0.833374H9.83334V2.41671H13.1667C14.5917 2.41671 15.75 3.57504 15.75 5.00004C15.75 6.42504 14.5917 7.58337 13.1667 7.58337H9.83334V9.16671H13.1667C15.4667 9.16671 17.3333 7.30004 17.3333 5.00004C17.3333 2.70004 15.4667 0.833374 13.1667 0.833374Z" />
  </svg>,
  'LinkAlt',
);
